export const chartOption1 = {
  styleId:1,
  pluginNames: [],
  refreshTime: 90000, //间隔刷新时间
  // 是否自动播放tooltip
  isAutoPlayToolTip: false,
  autoPlayToolTipIntervalTime: 1000,
  name: "全国",
  deepMap: false, //是否开启下钻的标识,
  zoom: 1.1, //地图缩放
  roam: false, //鼠标控制缩放
  center: [107.4, 33.42], //地图中心点经纬度
  areaColor: "rgba(46, 12, 144, 1)", //地图区块颜色
  primaryBorderColor: "rgba(48, 122, 255, 1)", //地图边框颜色
  primaryBorderWidth: 1, //地图边界默认border宽度
  selectBorderColor: "rgba(48, 122, 255, 1)", //地图边框颜色
  selectColor: "rgba(61, 225, 224, 1)", //地图选中和hover的颜色
  selectBorderWidth: 1, //地图边界选中border宽度
  showLabel: true,
  showScatter: false,
  showHot: false,
  showLines: false,
  label: {
    labelFontColor: "rgba(255, 255, 255, 0.7)",
    labelFontFamily: "sans-serif",
    labelFontSize: 8,
    labelFontWeight: 400
  },
  select: {
    selectFontColor: "rgba(255, 255, 255, 0.7)",
    selectFontFamily: "sans-serif",
    selectFontSize: 8,
    selectFontWeight: 400
  },
  scatter: {
    color: "rgba(27, 255, 254, 1)",
    rippleEffect: {
      color: {
        type: "linear",
        x: 0, //右
        y: 0, //下
        x2: 0, //左
        y2: 1, //上
        colorStops: [
          {
            offset: 0,
            color: "rgba(27, 255, 254, 1)" // 0% 处的颜色
          }
        ],
        global: false // 缺省为 false
      },
      number: 3,
      scale: 4, //动画中波纹的最大缩放比例
      brushType: "fill", //波纹的绘制方式，可选 'stroke' 和 'fill'
      period: 4 //动画的周期，秒数
    },
    label: {
      show: false,
      labelFontColor: "rgba(255, 255, 255, 0.7)",
      labelFontFamily: "sans-serif",
      labelFontSize: 8,
      labelFontWeight: 400,
      offset: [0, 20]
    },
    symbol: "circle", //'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
    symbolType: "circle",
    symbolImage: "",
    symbolSize: 8, //标记大小，包含中心点和波纹
    data: null,
    dataFormatter: [],
    selectName: ''
  },
  lines: {
    data: null, //飞线数据
    centerData: null, //飞线中心点数据
    lineStyle: {
      color: "#39CBE8",
      width: 1,
      type: "dotted",
      curveness: 0.3
    },
    effect: {
      show: true, //显示特效
      symbolSize: 5, //箭头大小
      period: 4, //箭头速度
      symbol: "arrow", //箭头图标
      trailLength: 0.02 //尾迹的长度
    },
    label: {
      show: false,
      position: "start",
      fontColor: "rgba(255, 255, 255, 0.7)",
      fontFamily: "sans-serif",
      fontSize: 8,
      fontWeight: 400
    }
  },
  visualMap: {
    type: "continuous",//piecewise
    mapeType:'china',
    show:true,
    min: 0,
    max: 1000,
    maxTimes: 1,
    calculable: true,
    orient: 'vertical',
    left: 10,
    top: 50,
    handleIcon:'circle',
    showHandleIcon:true,
    textStyle:{
      show:true
    },
    mapStartColor:'#54BAE9',
    mapEndColor:'#FF58C7',
    inRange: {
      color: []
    },
    dataFormatter: [],
  },
  tooltip:{
    show: false,
  },
  regionName: ''
}
